<template>
  <div class="product">
    <banner img="../assets/img/bgtop.jpg" title="Product" />
    <div class="product-content" v-loading="loading">
      <div class="lacking">
        <h3 class="title">Active Components</h3>
        <div class="lacking-bottom">
          <div
            class="lacking-bottom-item"
            v-for="(item, index) in productList"
            :key="index"
          >
            <div class="lacking-bottom-item-img" @click="zoomImage(item.img)">
              <img :src="item.img" :alt="item.alt" />
            </div>
            <p>{{ item.name }}</p>
          </div>
        </div>
        <div class="zoomed-image" v-if="zoomedImage" @click="resetZoom">
          <img :src="zoomedImage" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";

export default {
  data() {
    return {
      loading: true,
      zoomedImage: null,
      productList: [
        { img: "./img1/3.png", name: "CC1020RSSR", alt: "产品图片1" },
        { img: "./img1/4.png", name: "EP4CGX50CF23I7N", alt: "产品图片2" },
        { img: "./img1/5.png", name: "CC0402KRX7R7BB104", alt: "产品图片3" },
        { img: "./img1/6.png", name: "MC9S12DG128CFUE", alt: "产品图片4" },
        { img: "./img1/7.png", name: "XC7K70T-1FBG484I", alt: "产品图片5" },
        { img: "./img1/ISO3086TDWR.png", name: "ISO3086TDWR", alt: "产品图片6" },
        { img: "./img1/AD9643BCPZ-170.png", name: "AD9643BCPZ-170", alt: "产品图片7" },
        { img: "./img1/AD8402ARUZ50.png", name: "AD8402ARUZ50", alt: "产品图片8" },
        { img: "./img1/DS1685SN-3+.png", name: "DS1685SN-3+", alt: "产品图片9" },
        { img: "./img1/XC6SLX25-3FTG256C.png", name: "XC6SLX25-3FTG256C", alt: "产品图片10" },
        { img: "./img1/PA02A.png", name: "PA02A", alt: "产品图片11" },
        { img: "./img1/ADSP-BF548BBCZ-5A.png", name: "ADSP-BF548BBCZ-5A", alt: "产品图片12" }
      ]
    };
  },
  components: {
    Banner
  },
  mounted() {
    this.loading = false;
  },
  methods: {
    zoomImage(image) {
      this.zoomedImage = image;
    },
    resetZoom() {
      this.zoomedImage = null;
    }
  }
};
</script>

<style lang="scss" scoped>
.product {
  width: 100%;
  background-color: #14679f;
}

.product-content {
  width: 1240px;
  margin: 0 auto;
  background-color: #fff;
  padding: 20px; /* Added padding for better spacing */
  border-radius: 10px; /* Rounded corners for the content area */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); /* Subtle shadow for depth */
}

.lacking {
  padding: 20px 0;

  .title {
    font-size: 34px;
    font-weight: 600;
    color: #333;
    text-align: center;
    margin-bottom: 20px; /* Spacing below the title */
  }

  .lacking-bottom {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    padding: 20px;

    .lacking-bottom-item {
      width: 30%; /* Adjust as needed */
      margin: 15px 0; /* More space between items */
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;

      .lacking-bottom-item-img {
        width: 120px;
        height: 120px;
        border-radius: 10%;
        overflow: hidden;
        margin-bottom: 10px;
        transition: transform 0.3s ease; /* Hover effect */

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.3s ease;
        }

        &:hover img {
          transform: scale(1.1); /* Zoom effect on hover */
        }
      }

      p {
        font-size: 16px;
        color: #333;
        margin-top: 10px;
        text-align: center;
      }
    }
  }
}

.zoomed-image {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;

  img {
    max-width: 90%;
    max-height: 90%;
    border-radius: 10px; /* Rounded corners for zoomed image */
  }
}
</style>
